import appData from '../core/appData';

/**
 * Custom tracking events
 *
 * @returns {void}
 */
const analytics = () => {
    /**
     * Removes special characters and replaces spaces with dashes
     *
     * @param {string} inputString The value to convert
     * @returns {string} The converted value
     */
    const trackingSafeString = inputString => {
        // Step 1: Replace spaces with underscores and trim the string
        const trimmedString = inputString.trim().replace(/ +/g, '_');

        // Step 2: Remove any characters that are not alphanumeric, dashes or underscores
        const safeString = trimmedString.replace(/[^a-zA-Z0-9-_]/g, '');

        return safeString;
    };
    /**
     * Track selected filters
     *
     * @param {Object} selectedFilters Object of filter groups with the selected options
     */
    const trackFilters = selectedFilters => {
        // Filter data, including English labels
        const filterData = appData.getFilterData();

        // Split in 2 arrays, which are assignable to each other
        const filterCategories = [];
        const filterSelection = [];

        Object.keys(selectedFilters || {}).forEach(key => {
            const values = selectedFilters[key].values;

            // Lookup the English equivalent
            const category = trackingSafeString(filterData.refinements[key].labelEnglish);

            // Update both arrays one with lower case values
            filterCategories.push(category.toLowerCase());
            filterSelection.push(values.join(',').toLowerCase());
        });

        const dataEvent = {
            event: 'filter_interaction',
            filter_category: filterCategories,
            filter_selection: filterSelection
        };

        window.dataLayer.push(dataEvent);
    };

    /**
     * Handles the content worker done event
     *
     * @param {Object} event Custom event that contains the content worker result details
     */
    const handleContentWorkerDone = event => {
        if (event && event.detail) {
            // Filter event is fired after apply (and isPreview is false)
            if (event.detail.action === 'filter') {
                if (event.detail.isPreview === false) {
                    trackFilters(event.detail.selectedFilters);
                }
            }
        }
    };

    /**
     * Handles the view story event and opens the individual record view
     *
     */
    const handleViewStoryEvent = () => {
        // Get active story
        const activeStoryData = appData.getActiveStory();

        // Active story found? Push to the data layer
        if (activeStoryData) {
            const allTags = [];

            // Check if activeStoryData exists and has the necessary properties
            if (activeStoryData) {
                if (activeStoryData.year) {
                    allTags.push(activeStoryData.year);
                }
                if (activeStoryData.tags) {
                    allTags.push(...activeStoryData.tags);
                }
                if (activeStoryData.models) {
                    allTags.push(...activeStoryData.models);
                }
                if (activeStoryData.location) {
                    allTags.push(...activeStoryData.location.split(','));
                }
                if (activeStoryData.mediaType) {
                    allTags.push(...activeStoryData.mediaType.split(','));
                }
                if (activeStoryData.eras) {
                    allTags.push(...activeStoryData.eras.split(','));
                }
            }

            // Push the data to the data layer
            const dataEvent = {
                event: 'record_view',
                records: [
                    {
                        record_id: activeStoryData.id,
                        record_creative_name: activeStoryData.name,
                        record_tags: allTags.join(',')
                    }
                ]
            };

            window.dataLayer.push(dataEvent);
        }
    };

    /**
     * Initial data setup and event listeners
     */
    const init = () => {
        // Make sure there is a data layer
        window.dataLayer = window.dataLayer || [];

        // listener for (filtered) data results
        window.addEventListener('content.worker.done', handleContentWorkerDone);

        // Listener for individual record active story
        window.addEventListener('250.active.story', handleViewStoryEvent);
    };
    return {
        init
    };
};

export default analytics();
